function debounce(ms = 1000) {
  let tid: ReturnType<typeof setTimeout>

  return (cb: () => void) => {
    clearTimeout(tid)

    tid = setTimeout(cb, ms)
  }
}

export default debounce
